import { render, staticRenderFns } from "./NeoCamera.vue?vue&type=template&id=56f78bea&"
import script from "./NeoCamera.vue?vue&type=script&lang=js&"
export * from "./NeoCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports